import { postRequest, getRequest } from "../api/methodsCfg";

export const getAllModules = async () => {
  return await getRequest(`/api/modules`);
};

export const purchaseModule = async (userId, planId) => {
  return await postRequest(`/api/purchase`, { userId, planId });
};

export const getActiveModules = async (userId) => {
  return await getRequest(`/api/active/user/${userId}`);
};

export const getExpiredModules = async (userId) => {
  return await getRequest(`/api/expired/user/${userId}`);
};

export const regenerateApiKey = async (apiKeyId) => {
  return await postRequest(`/api/${apiKeyId}/regenerate`);
};

export const getUserApiUsageHistory = async (userId) => {
  return await getRequest(`/api/history/user/${userId}`);
};

export const getModuleApiUsageHistory = async (moduleId) => {
  return await getRequest(`/api/history/module/${moduleId}`);
};
